module.exports = __webpack_public_path__ + "static/media/a12.9804edce.ogg";